import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { type ApplyAttempt, fetchJson } from '@/lib/api';

export const useApplyFill = () => {
  const queryClient = useQueryClient();
  const { push } = useToast();

  return useMutation({
    mutationFn: (vars: { applicationId: number }) =>
      fetchJson<ApplyAttempt | null>(
        `/api/applications/${vars.applicationId}/apply`,
        { method: 'POST' },
      ),
    onError: (error: Error) =>
      push(error.message || 'Auto-fill failed', 'error'),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
      queryClient.invalidateQueries({ queryKey: ['stats'] });
      queryClient.invalidateQueries({
        queryKey: ['applyAttempt', vars.applicationId],
      });
    },
  });
};
